import { type InfiniteData } from '@tanstack/react-query'
import { PaginatedUploadManagerResponse, type UploadRow } from './interface'

export const formatUploadManagerData = (
    data: InfiniteData<PaginatedUploadManagerResponse> | undefined,
): UploadRow[] => {
    if (!data) return []
    return data.pages.flatMap((page) =>
        page.content.map((item) => ({
            id: item.id,
            fileUrl: item.fileUrl,
            createdAt: item.createdAt,
            userEmail: item.userEmail,
            templateName: item.templateName,
            fileName: item.fileName,
            errorReport: item.errorMessage ?? '',
            progress: item.progressPercent,
            status: item.status,
            totalRows: item.totalRows,
            processedRows: item.processedRows,
            errorFileUrl: item.errorFileUrl,
            errorRows: item?.errorRows,
        })),
    )
}
